<div class='row pt-2'>
  <div class='col'>
    <h5 class='text-center text-muted'>
      Kontaktdaten
    </h5>
  </div>
</div>

<hr>

<div class='row pt-2'>

  <div class='col' [formGroup]="contactForm">

    <div class="row form-group">

      <div class="col">
        <label for="Number">Telefon*</label>
        <input class="form-control" formControlName="Number" required>
        <small class="text-danger " *ngIf="!contactForm.controls.Number.valid ">
          <p>Muss ausgefüllt sein.</p>
        </small>
      </div>

      <div class="col">
        <label for="Address">Email*</label>
        <input class="form-control" formControlName="Address" required minlength="3">
        <small class="text-danger" *ngIf="!contactForm.controls.Address.valid">
          <p>Muss ausgefüllt sein.</p>
        </small>
      </div>

    </div>

  </div>
</div>